<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action>
            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">NOTICES
              </h1>
              <img
                src="../../../public/assets/images/notepad.png"
                class="title-section-img form-title-img ops-section-img"
                alt="background image"
              >
            </article>

            <article class="input-section form-section" style="padding-right: 50px;">
              <p>
                The Applicant's submission of this Application does not obligate the Company to issue, or the Applicant to purchase, a policy. The Applicant will be advised if the Application for coverage is accepted. The Applicant hereby authorizes the Company to make any inquiry in connection with this Application.               </p>
              <p>
                <strong>Notice to Arkansas, Louisiana, Maryland, Minnesota, New Mexico and Ohio Applicants:</strong>
                Any person who, with intent to defraud or knowing that he/she is facilitating a fraud against an insurer, submits an application or files a claim containing a false, fraudulent, or deceptive statement is, or may be found to be, guilty of insurance fraud, which is a crime, and may be subject to civil fines and criminal, penalties.
              </p>
              <p>
                <strong>Notice to Colorado Applicants:</strong>
                It is unlawful to knowingly provide false, incomplete or misleading facts or information to an insurance company for the purpose of defrauding or attempting to defraud the company. Penalties may include imprisonment, fines, denial of insurance, and civil damages. Any insurance company or agent of an insurance company who knowingly provides false, incomplete, or misleading facts or information to a policy holder or claimant for the purpose of defrauding or attempting to defraud the policy holder or claimant with regard to a settlement or award payable from insurance proceeds shall be reported to the Colorado Division of Insurance within the Department of Regulatory agencies.              </p>
              <p>
                <strong>Notice of District of Columbia, Maine, Tennessee and Virginia Applicants: </strong>
                It is a crime to knowingly provide false, incomplete or misleading information to an insurance company for the purpose of defrauding the company. Penalties may include imprisonment, fines or a denial of insurance benefits.
              </p>
              <p>
                <strong>Notice to Florida and Oklahoma Applicants: </strong>
                Any person who, knowingly and with intent to injure, defraud or deceive any employer or employee, insurance company, or self-insured program, files a statement of claim containing any false or misleading information is guilty of a felony [in Oklahoma) or a felony of the third degree (in Florida).
              </p>
              <p>
                <strong>Notice to Kentucky Applicants: </strong>
                Any person who, knowingly and with intent to defraud any insurance company 01· other person files an application for insurance containing any false information, or conceals for the purpose of misleading, information concerning any material fact thereto, commits a fraudulent insurance act which is a crime.              </p>
              <p>
                <strong>Notice to New Jersey Applicants:</strong>
                Any pe1-son who includes any false or misleading information on an application for an
                insurance policy is subject to criminal ,md civil penalties.               </p>
              <p>
                <strong>Notice to Oregon and Texas Applicants: </strong>
                Any person who makes an intentional misstatement th,:it is material to the risk may be found guilty of insurance fraud by a court of law.               </p>
              <p>
                <strong>Notice to Pennsylvania and New York Applicants: </strong>
                Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information, or concea Is for the purpose of misleading, in formation co nee rn i ng any fact rna te ria I the1·e to, comrn its a fraudulent i nsu ranee act, which is a crime and shall also be subject: to a civil penalty not to exceed five thousand dollars and the stated value of the claim for each such violation (in New York) or criminal and civil penalties (in Pennsylvania).               </p>
              <h5 class="font-weight-bold" style="text-align: center">
                ACKNOWLEDGEMENT, REPRESENTATIONS, & WARRANTIES
              </h5>

              <p>
                The applicant is authorized by and acting on behalf of all persons concerned seeking insurance, has read and understands this application and declares all statements set forth herein are true, complete, and accurate.
              </p>
              <p>
                The applicant further declares and represents that any happening, incident, or event taking place prior to the effective date of the insurance applied for which may render inaccurate, untrue, or incomplete any statement made herein will immediately be reported in writing to the insurer and the insurer may withdraw of modify any outstanding quotations and/or authorizations to bind the insurance or the policy, if a policy is issued.               </p>
              <p>
                The applicant acknowledges and agrees that the submission to and the insurer's receipt of such written report, prior to the inception of the policy applied for, is a condition precedent to coverage.
              </p>
              <p>
                The applicant by signing this application hereby authorizes, but does not require, the underwriters and/or their representatives to contact any prior insurer and obtain any details or prior loss information or obtain any other information from any source including consumer credit information, which the underwriters deem appropriate in the underwriting of the insurance applied for by this application.
              </p>
              <p>
                The applicant agrees that this application shall be the basis of the contract should a policy be issued and it will be attached to and become a part of the policy.
              </p>
              <p>
                The applicant acknowledges and agrees that the affixing of the applicant's signature to this application does not bind either the underwriter or the applicant to complete this insurance.
              </p>
            </article>
            <article class="input-section form-heading form-section review-sign">
              <div class="row mr-0 ml-0">
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Please print your name:</p>
                    <input
                        type="text"
                        class="orep-text-input notice-input"
                        placeholder="Type Your Name"
                        name="nameForFraudWarning"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        v-model="mgaApplication.nameForFraudWarning"
                    >
                    <span
                        v-show="errors.has('nameForFraudWarning')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('nameForFraudWarning') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Title:</p>
                    <input
                        type="text"
                        class="orep-text-input notice-input"
                        placeholder="Type Title"
                        name="titleForFraudWarning"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        v-model="mgaApplication.titleForFraudWarning"
                    >
                    <span
                        v-show="errors.has('titleForFraudWarning')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('titleForFraudWarning') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Signature:</p>
                    <input
                        type="text"
                        class="orep-text-input notice-input"
                        placeholder="Type Your Name to Sign"
                        name="clientSignature"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                        v-model="mgaApplication.clientSignature"
                    >
                    <span
                        v-show="errors.has('clientSignature')"
                        class="help is-danger form-errors text-danger"
                    >{{ errors.first('clientSignature') | filterText }}</span>
                  </section>
                </div>
                <div class="col-md-6">
                  <section class="notice-form mt-3">
                    <p class="notice-form-date">Date:</p>
                    <input
                        type="date"
                        class="orep-text-input notice-input text-center"
                        :value="formattedCurrentDate()"
                        disabled
                    >
                  </section>
                </div>
              </div>
              <div class="row mr-0 ml-0">
                <div class="col-md-8">
                  <p class="input-info pt-25">
                    <input
                        type="checkbox"
                        name="emailPolicy"
                        class="orep-radio w-40"
                        v-model="mgaApplication.emailPolicy"
                    >
                    <span
                        class="not-eligible-text email-me"
                        style="padding-left: 12px"
                    ><strong>Email Me a Copy of this Completed Application</strong></span>
                  </p>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div>
      <div class="row">
        <div class="col-md-12">
          <section class="flex wrap bottom-section">
            <router-link :to="{name:'ibdpro-mga-application-6'}" class="next-btn back-btn flex mont spaced">
              <i class="fas fa-arrow-left"></i>
              Back
            </router-link>
            <article class="orep-pagination">
              <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-1')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-2')"></button>
              <button class="pagination-dots" @click="navigateToPrev('ibdpro-mga-application-3')"></button>
              <button
                class="pagination-dots"
                @click="navigateToPrev('ibdpro-mga-application-4')">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToPrev('ibdpro-mga-application-5')">
              </button>
              <button
                  class="pagination-dots"
                  @click="navigateToPrev('ibdpro-mga-application-6')"
                  :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid">
              </button>
              <span class="pagination-dots pagination-current"></span>
            </article>

            <button
                type="submit"
                :disabled="!state.pageSevenIsValid"
                :class="{submitDisabled: !state.pageSevenIsValid}"
                class="next-btn mont spaced pull-right"
                @click="formSubmit()"
            >Submit</button>

          </section>
        </div>
      </div>
    </div>
    <div v-if="!!loading"
         class="position-fixed d-flex justify-content-center align-items-center w-100 h-100 bg-dark"
         style="opacity: 0.7; top: 0; left: 0;">
      <span class="text-white" style="font-size: 16px">Submitting the application...</span>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from 'moment';
import {APP_STATUS} from "@/utils/constants";

export default {
  name: "ibdpro-mga-application-7",
  data() {
    return {
      loading: false
    };
  },
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    mgaApplication() {
      return this.$store.state.mgaApplication.mgaApplication;
    },
    state() {
      return this.$store.state.mgaApplication;
    },
    errorMsg() {
      return this.$store.state.mgaApplication.errorMsg;
    }
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.loading = false;
          this.$notify({
            group: 'error',
            type: 'error',
            title: 'Error',
            text: this.errorMsg
          });
        }
      }
    }
  },
  methods: {
    navigateToPrev(route) {
      this.$router.push({
        name: route
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageSevenIsValid = true;
          return;
        }
        this.state.pageSevenIsValid = false;
      });
    },

    formattedCurrentDate() {
      return moment(this.mgaApplication.appraiserEsignatureDatetime).format('YYYY-MM-DD');
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    formSubmit() {
      this.loading = true;
      this.state.mgaApplication.customer.appStatus = APP_STATUS.Completed;
      this.$store.dispatch('mgaApplication/createMgaApplication');
    }
  },

  mounted() {
    $('html, body').animate({
        scrollTop: $('.page-content').offset().top
    }, 500);
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },

  components: {}
};
</script>
